import React from "react";
import { CONFIG } from "../../../../config/config";
import { IFormField } from "../../../../utils/form-utils";
import FormSection from "../../../shared-ui/form/form-section/form-section";
import { NumberInput } from "../../../shared-ui/input/number-input/number-input";
import styles from "./storage-reconstruction-section.module.scss";
import TooltipQuestion from "../../../shared-ui/tooltip-question";
import { Label } from "components/shared-ui/label";

export interface IStorageReconstructionSectionProps {
  isReadOnly: boolean;
  contentSecurityLevel: IFormField<number>;
  keySecurityLevel: IFormField<number>;
  metaSecurityLevel: IFormField<number>;

  maxContentSecurityLevel?: number;
  maxKeySecurityLevel?: number;
  maxMetaSecurityLevel?: number;

  contentRedundancyLevel: number;
  keyRedundancyLevel: number;
  metaRedundancyLevel: number;
}

const STORAGE_NODE_TOOLTIP = "Security Level / Redundancy Level";

export function StorageReconstructionSection(
  props: IStorageReconstructionSectionProps,
) {
  return (
    <FormSection
      testId="storage-reconstruction-section"
      title="Data Reconstruction"
      description={
        props.isReadOnly
          ? "The required number of shard repositories for data reconstruction"
          : "Please choose the required number of shard repositories for data reconstruction"
      }
    >
      {props.isReadOnly && (
        <div
          data-testid="security-params"
          className={styles["security-params--readonly"]}
        >
          <Label
            label="Content"
            value={
              <div data-testid="content">
                {`${props.contentSecurityLevel.value}/${props.contentRedundancyLevel}`}
                <TooltipQuestion>{STORAGE_NODE_TOOLTIP}</TooltipQuestion>
              </div>
            }
          />
          <Label
            label="Key"
            value={`${props.keySecurityLevel.value}/${props.keyRedundancyLevel}`}
          />
          <Label
            label="metadata"
            value={`${props.metaSecurityLevel.value}/${props.metaRedundancyLevel}`}
          />
        </div>
      )}

      {!props.isReadOnly && (
        <div
          data-testid="security-params"
          className={styles["security-params"]}
        >
          <div data-testid="content" className={styles["security-param"]}>
            <label className={styles["param-label"]}>Content:</label>
            <div className={styles["param-value"]}>
              <NumberInput
                testId="content"
                min={CONFIG.minSecurityLevel}
                max={props.maxContentSecurityLevel}
                field={props.contentSecurityLevel}
                showButtons={true}
              />
            </div>
          </div>

          <div data-testid="key" className={styles["security-param"]}>
            <label className={styles["param-label"]}>Key:</label>
            <div className={styles["param-value"]}>
              <NumberInput
                testId="key"
                min={CONFIG.minSecurityLevel}
                max={props.maxKeySecurityLevel}
                field={props.keySecurityLevel}
                showButtons={true}
              />
            </div>
          </div>

          <div data-testid="metadata" className={styles["security-param"]}>
            <label className={styles["param-label"]}>Metadata:</label>
            <div className={styles["param-value"]}>
              <NumberInput
                testId="metadata"
                min={CONFIG.minSecurityLevel}
                max={props.maxMetaSecurityLevel}
                field={props.metaSecurityLevel}
                showButtons={true}
              />
            </div>
          </div>
        </div>
      )}
    </FormSection>
  );
}
